import { useState } from 'react'
import useSWR, { mutate } from 'swr'
import { Update_Book } from '@graphql/mutations'
import { Books_Listing, Library_Books, Single_Book } from '@graphql/queries'
import { useApi } from '@hooks/useApi'

const useUpdateBook = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Update_Book,
      successMessage,
      errorMessage,
      async () => {
        await mutate(Books_Listing) // refetch books listing
        await mutate(Library_Books)
        await mutate([Single_Book, data.id]) // refetch single book
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateBook }
